
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bepaal-statuut",
      function () {
        return require("private-next-pages/bepaal-statuut.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bepaal-statuut"])
      });
    }
  